import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FavoriteModalIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="90"
      viewBox="0 0 84 90"
    >
      <g id="Illustration" transform="translate(-906 -326)">
        <g id="Group_10849" data-name="Group 10849">
          <rect
            id="Rectangle_1862"
            data-name="Rectangle 1862"
            width="84"
            height="84"
            rx="4"
            transform="translate(906 332)"
            fill="#fb972e"
          />
          <rect
            id="Rectangle_1863"
            data-name="Rectangle 1863"
            width="76"
            height="76"
            rx="2"
            transform="translate(910 336)"
            fill="#fee0c0"
          />
          <rect
            id="Rectangle_1864"
            data-name="Rectangle 1864"
            width="76"
            height="4"
            transform="translate(910 351)"
            fill="#fb972e"
          />
        </g>
        <g id="Group_10848" data-name="Group 10848">
          <path
            id="Path_10376"
            data-name="Path 10376"
            d="M28.1,3A10.779,10.779,0,0,0,20,6.762,10.779,10.779,0,0,0,11.9,3,9.8,9.8,0,0,0,2,12.9c0,6.8,6.12,12.348,15.39,20.772L20,36.03l2.61-2.376C31.88,25.248,38,19.7,38,12.9A9.8,9.8,0,0,0,28.1,3Z"
            transform="translate(928 364.895)"
            fill="#fff"
          />
          <path
            id="Path_10375"
            data-name="Path 10375"
            d="M28.1,3A10.779,10.779,0,0,0,20,6.762,10.779,10.779,0,0,0,11.9,3,9.8,9.8,0,0,0,2,12.9c0,6.8,6.12,12.348,15.39,20.772L20,36.03l2.61-2.376C31.88,25.248,38,19.7,38,12.9A9.8,9.8,0,0,0,28.1,3ZM20.18,30.99l-.18.18-.18-.18C11.252,23.232,5.6,18.1,5.6,12.9a6.152,6.152,0,0,1,6.3-6.3,7.037,7.037,0,0,1,6.426,4.248h3.366A6.992,6.992,0,0,1,28.1,6.6a6.152,6.152,0,0,1,6.3,6.3C34.4,18.1,28.748,23.232,20.18,30.99Z"
            transform="translate(928 364.895)"
            fill="#fb972e"
          />
        </g>
        <g id="Group_10846" data-name="Group 10846">
          <rect
            id="Rectangle_1865"
            data-name="Rectangle 1865"
            width="12"
            height="18"
            rx="6"
            transform="translate(918 326)"
            fill="#fb972e"
          />
          <rect
            id="Rectangle_1866"
            data-name="Rectangle 1866"
            width="4"
            height="10"
            rx="2"
            transform="translate(922 330)"
            fill="#fff"
          />
        </g>
        <g id="Group_10845" data-name="Group 10845" transform="translate(24)">
          <rect
            id="Rectangle_1869"
            data-name="Rectangle 1869"
            width="12"
            height="18"
            rx="6"
            transform="translate(918 326)"
            fill="#fb972e"
          />
          <rect
            id="Rectangle_1870"
            data-name="Rectangle 1870"
            width="4"
            height="10"
            rx="2"
            transform="translate(922 330)"
            fill="#fff"
          />
        </g>
        <g id="Group_10847" data-name="Group 10847">
          <rect
            id="Rectangle_1867"
            data-name="Rectangle 1867"
            width="12"
            height="18"
            rx="6"
            transform="translate(966 326)"
            fill="#fb972e"
          />
          <rect
            id="Rectangle_1868"
            data-name="Rectangle 1868"
            width="4"
            height="10"
            rx="2"
            transform="translate(970 330)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
